export const CS_URL = 'https://programmers.channel.io/workflows/696340';
